import { create } from 'zustand';
import { Folders } from '../types/file';

type TLoginStore = {
  folders: Folders,
  setFolders(files: TLoginStore['folders']): void,
};
const useFolderStore = create<TLoginStore>(set => ({
  folders: [],
  setFolders: (folders: TLoginStore['folders']) => set(_state => ({ folders })),
}));

export default useFolderStore;
